<template>
  <div data-testid="capacity-database-wrapper">
    <Hero
      v-if="!hasAuthorized && hero"
      :initial-fields="hero.initialFields"
      :title="hero.title"
      :image="hero.images.desktop"
      :file="hero.file"
      download-text="Methodology"
    >
      <template #extra-ctas>
        <ButtonBookADemo />
      </template>
    </Hero>
    <div
      class="mx-auto flex w-full max-w-content-container flex-col justify-center gap-y-7 px-small pb-20 pt-8 md:items-start xl:pb-36 xl:pl-16 xl:pr-0 xl:pt-10"
    >
      <Breadcrumb v-if="hasAuthorized" :menu="breadcrumbStore.items" />
      <TitleWithIcon v-if="title" :icon="title.icon" :title="title.text" />

      <section class="w-full">
        <TheTabsBySlug
          v-if="tabs && tabs.length"
          :tabs="tabs"
          class="mb-4"
          @active-tab-changed="$emit('active-tab-changed', $event)"
        />

        <TheLoader v-if="loading" class="min-h-[70dvh]" />
        <div v-else class="relative h-full">
          <slot />
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
/** components */
import Hero from '~/components/shared/services/Hero.vue'
import Breadcrumb from '~/components/shared/navigation/Breadcrumb.vue'
import TheTabsBySlug from '~/components/common/TheTabsBySlug.vue'
import TitleWithIcon from '~/components/price-assessments/SectionTitle.vue'
import ButtonBookADemo from '~/components/shared/common/ButtonBookADemo.vue'

/** stores */
import { useBreadcrumbStore } from '~/stores/breadcrumb'

/** types */
import type { TCDTitle } from '~/src/types/capacity-database'
import type { THeroDeprecated } from '~/src/types/common'
import type { TTab } from '~/src/types/ui'
import useAuthStore from '~/stores/auth'

/** props */
const props = defineProps<{
  hero?: THeroDeprecated
  title: TCDTitle
  tabs?: TTab[]
  isAuthorized?: boolean
}>()

/** refs */
const loading = ref(false)

/** app */
const breadcrumbStore = useBreadcrumbStore()
const authStore = useAuthStore()

/** computed */
const isAuthenticated = computed(() => authStore.authenticated)
const hasAuthorized = computed(
  () => props.isAuthorized || isAuthenticated.value,
)
</script>
